import { createI18n } from 'vue-i18n'
import { IAppApplication } from '@/app/application'
import { LocalStorageLanguage } from '@/constants'
import { Locales } from '@/types'
import de from '@/i18n/de'
import en from '@/i18n/en'
import fr from '@/i18n/fr'
import nl from '@/i18n/nl'
import type { AppStore } from '@/store/types'

const defaultLocale = localStorage.getItem(LocalStorageLanguage) || Locales.En
const messages = {
  [Locales.En]: en,
  [Locales.Nl]: nl,
  [Locales.De]: de,
  [Locales.Fr]: fr,
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: defaultLocale,
  fallbackLocale: Locales.En,
  messages: messages as Record<string, any>,
  missingWarn: true,
  fallbackWarn: false,
})

let isI18nInitialized = false

export function installI18nPlugin(app: IAppApplication, _store: AppStore): void {
  app.use(i18n)
}

export function initializeI18n(): void {
  if (isI18nInitialized) return
  isI18nInitialized = true
}
